<template lang="pug">
#device
  el-alert.dirty(type="warning" :title="$t('Cuona.Device.NfcUpdate.single_is_dirty')" :closable="false" show-icon v-if="isDirtyNFC && online")
    el-button(type="warning" @click="updateNFC" size="mini") {{ $t('Cuona.Device.update')}}
  .content(v-loading="isLoading" v-visibility-change="visibilityChange")
    template(v-if="device")
      .device
        el-row
          el-col.cuona
            img(:src="images[device.device_type]")
          el-col.command
            p.condition(v-if="device.device_type === 'cube'")
              span.statusView(:class="checkOnLine(online)")
                span.status(:class="checkOnLine(online)")
                | {{ checkOnLineString(online) }}
              span.message {{ showMessage() }}
            p.mode(v-if="status !== null && status.development === 1")
              span.developView
                i.el-icon-info
                | {{ $t('Cuona.Device.dev_mode') }}

      .detail
        h2 {{ $t('Cuona.Device.title02', {name: device.name}) }}
          a.edit(@click="showDialog")
            i.el-icon-edit
            | {{ $t('Cuona.Device.setting') }}
        p(v-show="device.note")
        .info
          el-row(:gutter="20")
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.name') }}
              span.value {{ device.name }}
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.nfc_uid') }}
              span.value {{ device.nfc_uid }}
          el-row(:gutter="20")
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.latlng') }}
              span.value {{ showDeviceLatLon() }}
            el-col(:span="12")
          el-row(:gutter="20" v-if="status")
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.firmware_version') }}
              span.value {{ status.version }}
              a.edit(@click="updateFirmwareView" v-show="hasUpdate && !isUpdating")
                i.el-icon-warning
                | {{ $t('Cuona.Device.update_firmware') }}
              span.updating(v-show="isUpdating")
                i.el-icon-refresh
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.touch_sound') }}
              span.value {{ showSetSound(status.set_sound) }}
              a.edit(@click="playSoundView")
                i.el-icon-bell
                | {{ $t('Cuona.Device.set_touch') }}
          el-row(:gutter="20" v-if="status")
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.uptime') }}
              span.value {{ status.uptime }}
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.temperature') }}
              span.value {{ status.temperature }} ℃
          el-row(:gutter="20" v-if="status")
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.humidity') }}
              span.value {{ status.humidity }} %
            el-col(:span="12")
              span.item {{ $t('Cuona.Device.pressure') }}
              span.value {{ status.pressure }} hPa
          el-row(:gutter="20")
            el-col(:span="12" v-if="0 < device.groups.length")
              h3 {{ $t('Cuona.Device.group_name') }}
              .groups
                template(v-for="group in device.groups")
                  router-link.group(:to="{path: '/cuona/group/' + group.id }")
                    h4 {{ group.name }}
                    p.manager
                      img(:src="isEmptyImg(group.manager.thumb_url)" class="thumb")
                      | {{ group.manager.name }}

            el-col(:span="12" v-if="0 < device.events.length")
              h3 {{ $t('Cuona.Device.events') }}
              .events
                template(v-if="!device.events")
                  .event
                    span {{ $t('Cuona.Device.unsetting') }}
                template(v-else)
                  template(v-for="(event, index) in device.events")
                    router-link.event(:class="event.action_type" :to="{path: '/cuona/event/' + event.id }")
                      img.type(:src="showActionIcon(event.action_type)")
                      h3 {{ event.name }}
      //- .continue
      //-   h2 {{ $t('Cuona.Device.title01') }}
      //-   .history_console
      //-     History(:id="device.nfc_uid")

      //- 名前変更ダイアログ
      el-dialog(:title="$t('Cuona.Device.title03')" :visible.sync="isShowingDialog")
        .input-form
          label.caution {{ $t('Cuona.Device.name') }}
          el-input.label(v-model="updateDeviceDialog.deviceName" :placeholder="$t('Cuona.Device.message01')")
        .input-form
          label.double {{ $t('Cuona.Device.latlng') }}
          el-input.lat(v-model="updateDeviceDialog.lat" :placeholder="$t('Cuona.Device.lat')")
          el-input.lon(v-model="updateDeviceDialog.lon" :placeholder="$t('Cuona.Device.lon')")
        span.dialog-footer(slot="footer")
          el-button(@click="isShowingDialog=false") {{ $t('Cuona.Device.cancel') }}
          el-button(type="primary" @click="doneDeviceUpdate") {{ $t('Cuona.Device.dochange') }}

      //- ファームウェアアップデートダイアログ
      el-dialog(:title="$t('Cuona.Device.title07')" :visible.sync="isShowingFirmwareDialog")
        template(v-if="hasUpdate && status")
          p {{ $t('Cuona.Device.description09') }}
          p.version
            span.oldVersion {{ status.version }}
            i.el-icon-back.rightarrow
            span.newVersion {{ this.company.firmware.version }}
        template(v-else)
          p {{ $t('Cuona.Device.description10') }}
        span.dialog-footer(slot="footer")
          el-button(@click="isShowingFirmwareDialog=false") {{ $t('Cuona.Device.cancel') }}
          el-button(type="primary" @click="startUpdate" v-show="hasUpdate") {{ $t('Cuona.Device.update') }}

      //- 音声設定変更ダイアログ
      el-dialog.soundDialog(:title="$t('Cuona.Device.title06')" :visible.sync="isShowingPlaySoundDialog" @close="closePlaySoundDialog")
        el-form(label-position="left" ref="playSoundDialogForm" :model="playSoundDialogForm")
          p {{ $t('Cuona.Device.description04', {name: device.name }) }}
          el-select.choiceSound(v-model="playSoundDialogForm.soundId" @change="resetPlaySoundDialog")
            el-option(v-for="item in options" :key="item.value" :label="item.label" :value="item.value") {{ item.label }}
              i.el-icon-bell.selected(v-if="item.default")
          .volume
            span {{ $t('Cuona.Device.volume') }}
            el-slider(v-model="playSoundDialogForm.volume")
            span.volume_value {{ playSoundDialogForm.volume }}
          el-button(@click="playSound(playSoundDialogForm.soundId)" :disabled="playBtnEnabled") {{ $t('Cuona.Device.play_sound') }}

          template(v-if="playSoundDialogForm.soundId == 2")
            transition(name="fade")
              el-upload.upload(action="" :auto-upload="false" :on-change="setCustomAudio" :show-file-list="false" v-if="playSoundDialogForm.isShowingUploader" drag)
                i.el-icon-upload
                .el-upload__text(v-html="$t('Cuona.Device.description07')")
                .el-upload__tip(v-html="$t('Cuona.Device.description08')")
            p(v-if="playSoundDialogForm.isShowingUploading")
              i.el-icon-loading
              span.uploading {{ $t('Cuona.Device.uploading') }}
            div(v-else-if="playSoundDialogForm.isShowingUploaded")
              p.success {{ $t('Cuona.Device.complete_upload') }}
              el-button(@click="resetPlaySoundDialog" type="text")
                i.el-icon-upload
                | {{ $t('Cuona.Device.reopen_uploader') }}

        span.dialog-footer(slot="footer")
          el-button(@click="closePlaySoundDialog") {{ $t('Cuona.Device.close') }}
          el-button.setting(type="primary" @click="setTouchSound(playSoundDialogForm.soundId, 50)" :disabled="playBtnEnabled") {{ $t('Cuona.Device.set_sound') }}

</template>

<script>
import { mapGetters } from 'vuex'
import actions from '@/utils/defines/actions.js';
import Latest from './Latest'
import History from './History'
import Api from '@/api/cuona'
import IotProxyApi from '@/api/iot_proxy'
import DeviceApi from '@/api/cuona'
export default {
  mixins: [actions],
  data () {
    return {
      isLoading: true,
      device: null,
      isShowingDialog: false,
      isShowingPlaySoundDialog: false,
      isShowingSetSoundDialog: false,
      isShowingFirmwareDialog: false,
      playSoundDialogForm: {
        soundId: 0,
        volume: 50,
        customAudioFile: null,
        isShowingUploader: true,
        isShowingUploading: false,
        isShowingUploaded: false
      },
      hasUpdate: false,
      isUpdating: false,
      isDirtyNFC: false,
      updateDeviceDialog: {
        deviceName: '',
        lat: null,
        lon: null,
        deviceStatus: true
      },
      intervalId: null,
      setTimeId: null,
      options: [{
        label: this.$t('Cuona.Device.default_sound1'),
        value: 0,
        default: true
      },
      {
        label: this.$t('Cuona.Device.default_sound2'),
        value: 1,
        default: false
      },
      {
        label: this.$t('Cuona.Device.original_sound'),
        value: 2,
        default: false
      }],
      playBtnEnabled: false,
      status: null,
      online: false,
      selectedServiceKeys: [],
      images:{
        cube: require('@/assets/cuona_cube.png'),
        tag: require('@/assets/cuona_tag.svg')
      },
      rules: {
        deviceName: [
          { required: true, message: this.$t('Cuona.Device.message01'), trigger: 'blur' }
        ]
      }
    }
  },
  components: { Latest, History },
  mounted () {
    this.getDevice(this.$route.params.id);
    this.intervalId = setInterval(this.getStatus, 60000);
  },
  beforeDestroy () {
    clearInterval(this.intervalId);
    clearInterval(this.setTimeId);
  },
  computed: {
    ...mapGetters([
      'company'
    ]),

    // デバイスに登録されているサービスのキー
    registeredServiceKeys: function() {
      var registeredServiceKeys = []
      for(var i = 0; i < this.device.services.length; i++) {
        registeredServiceKeys.push(this.device.services[i].service_key)
      }
      return registeredServiceKeys
    }
  },
  watch : {
    device : function() {
      if(this.device.name) {
        this.$store.commit('setLastBreadcrumb', this.device.name);
        this.setPageTitle(this.device.name);
      }
    }
  },
  methods: {

    getDevice: function (nfcUid) {
      DeviceApi.getDevice(nfcUid)
        .then(device => {
          this.device = device;
          this.getStatus();
          if(device.status === 'updating') {
            this.isUpdating = true;
          }
          if(device.status === 'dirty') {
            this.isDirtyNFC = true;
          }
        })
        .catch((error) => {
          this.$router.replace('/cuona/device');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Device.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    updateNFC: function () {
      IotProxyApi.updateNfc(this.device.nfc_uid)
        .then(res => {
          if (res.status === 'success') {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.single_success'),
              type: 'success'
            });
            this.isDirtyNFC = false;
          }
          if (res.status === 'error') {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.single_error'),
              type: 'error'
            })
          }
          if (res.status === 'timeout') {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.single_timeout'),
              type: 'error'
            })
          }
        });
    },

    // 位置情報を取得
    showDeviceLatLon: function(){
      if (this.device.lat && this.device.lon) {
        return this.device.lat + ", " + this.device.lon
      } else {
        return this.$t('Cuona.Device.unsetting')
      }
    },

    // 表示メッセージを切替
    showMessage: function() {
      if (this.online) {
        return this.hasUpdate ? this.$t('Cuona.Device.description06') : this.$t('Cuona.Device.description05');
      } else {
        return this.$t('Cuona.Device.description11');
      }
    },

    // 設定ダイアログを表示
    showDialog: function() {
      this.updateDeviceDialog.deviceName = this.device.name
      this.updateDeviceDialog.lat = this.device.lat
      this.updateDeviceDialog.lon = this.device.lon
      this.isShowingDialog = true
    },

    // 設定を完了
    doneDeviceUpdate: function() {
      if (this.updateDeviceDialog.deviceName.length === 0) {
        return false
      }
      const payload = {
        nfc_uid: this.device.nfc_uid,
        params: {
          name: this.updateDeviceDialog.deviceName,
          lat: this.updateDeviceDialog.lat || null,
          lon: this.updateDeviceDialog.lon || null
        }
      }
      this.isLoading = true;
      DeviceApi.updateDevice(payload)
        .then((device) => {
          this.device = device;
          this.isShowingDialog = false;
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Device.message02'),
            type: 'success'
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Device.failed_update'),
            type: 'error'
          });
        }).finally(() => {
          this.isLoading = false;
        });
    },

    // サムネイルのデフォルト表示
    isEmptyImg: function(url){
      return url != null ? url : require("@/assets/default.svg")
    },

    // オンラインオフラインを返す
    checkOnLine: function (flg) {
      return flg ? 'online' : 'offline'
    },

    checkOnLineString: function (flg) {
      return flg ? this.$t('Cuona.Device.online') : this.$t('Cuona.Device.offline')
    },

    closePlaySoundDialog: function () {
      this.isShowingPlaySoundDialog = false
    },

    playSoundView: function () {
      this.playSoundDialogForm.soundId = this.status.set_sound || 0
      this.isShowingPlaySoundDialog = true
    },

    updateFirmwareView: function () {
      this.isShowingFirmwareDialog = true
    },

    startUpdate: function () {
      this.isShowingFirmwareDialog = false
      const that = this
      IotProxyApi.startOta(this.status.id, this.company.firmware.url, this.company.firmware.version).then(function (response) {
          if (response.timeout) {
            that.$message({
              showClose: true,
              message: that.$t('Cuona.Device.message08'),
              type: 'error'
            })
          } else {
            const payload = {
              nfc_uid: that.device.nfc_uid,
              params: {
                device: {
                  status: 'updating'
                }
              }
            }
            that.$store.dispatch('updateDevice', payload)
            .then(() => {
              that.isUpdating = true
              that.$message({
                showClose: false,
                message: that.$t('Cuona.Device.message07'),
                type: 'success'
              })
            }).catch((e) => {
              console.log(e);
            })
          }
      })
    },

    getStatus: function () {
      if(!this.device) return;

      const that = this;
      IotProxyApi.getStatus(this.device.nfc_uid)
        .then(function(response) {
          if (response.timeout) {
            that.status = null
            that.online = false
          } else {
            that.status = response.data.data
            that.status.temperature = Math.round((that.status.temperature - 5) * 100)/100;
            that.status.humidity = Math.round(that.status.humidity * 100)/100;
            that.online = true
            that.setDefaultSoundIcon(that.status.set_sound)
            that.playSoundDialogForm.volume = Math.round(( that.status.set_volume / 255 ) * 100)

            if(that.setTimeId == null){
              that.setTimeId = setTimeout(that.updateUpTimer, 1000)
            }
            if (that.status.ota == "updating"){
              clearInterval(that.intervalId)
              clearTimeout(that.setTimeId)
              that.status.uptime = "--"
              that.isUpdating = true
            }
            if (that.status.ota == "failed") {
              that.isUpdating = false
              that.$message({
                showClose: false,
                message: that.$t('Cuona.Device.message08'),
                type: 'error'
              })
            }

            if (that.company.firmware == null) {
              that.getFirmware()
            } else {
              if (that.status.version !== that.company.firmware.version) {
                that.hasUpdate = true
              } else {
                if(that.isUpdating) {
                  const payload = {
                    nfc_uid: that.device.nfc_uid,
                    params: {
                      device: {
                        status: 'normal'
                      }
                    }
                  }
                  that.$store.dispatch('updateDevice', payload)
                  .then(() => {
                    that.isUpdating = false
                    that.hasUpdate = false
                    that.$message({
                      showClose: false,
                      message: that.$t('Cuona.Device.message11'),
                      type: 'success'
                    })
                  }).catch((e) => {
                    console.log(e);
                  })
                }
              }
            }
          }
        })
    },

    visibilityChange: function(evt, hidden)
    {
      if (hidden){
        clearInterval(this.intervalId)
      } else {
        this.getStatus()
      }
    },

    playSound: function(soundId) {
      this.playBtnEnabled = true;
      const that = this;
      IotProxyApi.playSound(this.device.nfc_uid, soundId, this.playSoundDialogForm.volume)
        .then(function(response) {
          if (!response.success) {
            that.$message({
              showClose: true,
              message: response.success.message,
              type: 'error'
            })
          }
          that.playBtnEnabled = false;
        })
    },

    updateUpTimer: function ()
    {
      if (this.status == null) {
        return
      }
      let uptime = this.status.uptime
      let result = uptime.split(':')
      let hour   = Number(result[0])
      let min    = Number(result[1])
      let sec    = Number(result[2]) + 1

      if (sec === 60){
        min++
        sec = 0
      }
      if (min === 60){
        hour++
        min = 0
      }
      if(min < 10) { min = "0" + min }
      if(sec < 10) { sec = "0" + sec }

      this.status.uptime = hour + ":" + min + ":" + sec
      setTimeout(this.updateUpTimer, 1000)
    },

    setDefaultSoundIcon: function (id)
    {
      this.options.map(function (option, index) {
        option.default = (index === id) ? true : false
        return option
      })
    },

    setTouchSound: function (soundId) {
      const that = this;
      IotProxyApi.setTouchSound(this.device.nfc_uid, soundId, this.playSoundDialogForm.volume)
        .then(function(response) {
          if (!response.timeout) {
            that.status.set_sound = soundId
            that.setDefaultSoundIcon(soundId)
            that.$message({
              showClose: false,
              message: that.$t('Cuona.Device.message05'),
              type: 'success'
            })
          } else {
            that.$message({
              showClose: true,
              message: that.$t('Cuona.Device.message06'),
              type: 'error'
            })
          }
        })
        .finally(function() {
          that.closePlaySoundDialog()
        })
    },

    showSetSound: function(sound_id)
    {
      let option = this.options.filter(function(option, index){
        return sound_id === option.value
      })
      return option[0].label
    },

    getNfcData: function() {
      IotProxyApi.getNfcData(this.device.nfc_uid)
        .then(function(response) {
        })
    },

    startOta: function(url, version) {
      IotProxyApi.startOta(this.device.nfc_uid, url, version)
        .then(function(response) {
        })
    },

    initNfc: function() {
      IotProxyApi.initNfc(this.device.nfc_uid)
        .then(function(response) {
          console.log(response);
        })
    },

    getFirmware: function(version = null) {
      const that = this;
      Api.getFirmware(version)
        .then(function(response) {
          if (that.status.version !== response.version) {
            that.hasUpdate = true
            that.company.firmware = response
          }
        })
    },

    setCustomAudio: function (file, fileList)
    {
      if (300000 < file.size) {
        this.$message({
          showClose: true,
          message: this.$t('Cuona.Device.message09'),
          type: 'error'
        })
        return false
      }
      if (file.raw.type === "audio/wav" || file.raw.type === 'audio/x-wav' || file.raw.type === "audio/mpeg") {
        this.playSoundDialogForm.customAudioFile = fileList.slice(-1)[0];
        this.updateAudio(this.playSoundDialogForm.soundId);
      } else {
        this.$message({
          showClose: true,
          message: this.$t('Cuona.Device.message10'),
          type: 'error'
        })
      }
    },

    updateAudio: function (soundId) {

      // updateAudio開始時の処理
      this.playSoundDialogForm.isShowingUploader = false;
      this.playSoundDialogForm.isShowingUploading = true;

      const that = this;
      const file = this.playSoundDialogForm.customAudioFile;
      IotProxyApi.updateAudio(this.device.nfc_uid, file.raw, soundId)
        .then(function(response) {
          that.successUpdateAudio();
        })
    },

    successUpdateAudio: function () {

      // updateAudio成功時の処理
      this.playSoundDialogForm.isShowingUploading = false;
      this.playSoundDialogForm.isShowingUploaded = true;
    },

    resetPlaySoundDialog: function () {
      this.playSoundDialogForm.isShowingUploader = true;
      this.playSoundDialogForm.isShowingUploading = false;
      this.playSoundDialogForm.isShowingUploaded = false;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.device {
  img {
    width: 180px;
    margin: -30px 0 0 25px;
    position: relative;
    z-index: 1;
  }
  .el-row {
    display: flex;
    .el-col {
      &.cuona {
        width: 250px;
      }
      &.command {
        p.latest {
          margin: 0 0 5px 0;
          font-size: 12px;
        }
      }
      &.config {
        width: 50px;
        margin: 5px 15px 0 0;
        a {
          cursor: pointer;
          font-size: 24px;

          &:hover {
            color: $safe;
          }
        }
      }
    }
  }
  a.sound {
    position: absolute;
    display: inline-block;
    cursor: pointer;
    text-align: center;
    line-height: 28px;
    width: 28px;
    height: 28px;
    background: #666;
    margin: 98px 0 0 -58px;
    border: 1px solid #666;
    color: #CCC;
    border-radius: 16px;

    &:hover {
      border: 1px solid #666;
      background: #CCC;
      color: #666;
    }
  }
}

.volume {
  display: inline-block;

  span {
    display: inline-block;
    &.volume_value {
      width: 25px;
      margin: 0 10px;
    }
  }
  .el-slider {
    display: inline-block;
    vertical-align: middle;
    width: 220px;
    margin: 0 10px 0 20px;
  }
}

.el-button {
  i.el-icon-upload {
    margin-right: 3px;
  }
}

.el-alert {
  &.dirty {
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
}

.el-alert ::v-deep {
  .el-alert__title.is-bold {
    font-weight: normal;
  }
  .el-alert__description {
    display: inline-block;
    margin: 0;
    .el-button {
      margin-left: 10px;
    }
  }
}

span.uploading, p.success {
  color: #5baf31;
}

i.selected {
  position: absolute;
  right: 0;
  margin: 10px;
}

i.el-icon-back.rightarrow {
  margin: 0 8px 0 5px;
  transform: rotateY(180deg);
}

p.version {
  font-size: 16px;
}

.el-select.choiceSound {
  margin-right: 10px;
}

.soundDialog ::v-deep {
  .el-dialog {
    min-width: 720px;
  }
}

.upload ::v-deep {
  margin: 10px 0 0 0;

  .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
    }
  }
}

p.condition, p.mode {
  font-size: 13px;
  padding: 0;
  margin: 25px 0 5px -20px;

  span.developView {
    background: #CCC;
    padding: 3px 8px 3px 19px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;

    i {
      margin-right: 3px;
    }
  }

  span.statusView {
    padding: 3px 8px 3px 20px;
    margin-right: 5px;
    font-weight: bold;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;

    &.online {
      background: #70D035;
      color: #FFF;
    }
    &.offline {
      background: #EEE;
      color: #333;
    }

    span.status {
      background: #EEE;
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      margin-right: 5px;
      vertical-align: middle;

      &.online {
        background: #FFF;
      }
      &.offline {
        background: #BBB;
      }
    }
  }
}

p.mode {
  margin: 8px 0 0 -20px;
}

.continue, .detail {
  border-top: 1px solid $border;

  > h2,
  > h3 {
    font-size: 16px;
    font-weight: normal;
    margin: 30px 0 20px 40px;

    a.reload {
      transition: all .3s ease-in-out;
      cursor: pointer;
      display: inline-block;
      font-size: 12px;
      border: 1px solid $border;
      border-radius: 14px;
      padding: 3px 10px 3px 6px;
      margin-left: 10px;
      vertical-align: bottom;

      i {
        &:before {
          margin-right: 3px;
        }
      }

      &:hover {
        border: 1px solid $safe;
        background: rgba(0,156,225,0.1);
        color: $safe;
      }
    }
  }

  .el-row {

    .el-col {
      > h3 {
        display: block;
        font-size: 14px;
        font-weight: normal;
        margin: 30px 0 20px 0;
        border-bottom: 1px solid $border;
      }
    }
  }

  .graph, .history_console {
    margin: 0 40px 30px 40px;
  }
}

.el-dialog {
  width: 40% !important;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.detail {
  border: none;
  h2 {
    margin-top: 10px;

    a {
      &.edit {
        color: #666;
        cursor: pointer;
        transition: all .3s ease-in-out;
        display: inline-block;
        background: #FFF;
        margin-left: 10px;
        margin-right: -10px;
        border: 1px solid $border;
        font-size: 11px;
        border-radius: 20px;
        padding: 3px 8px 3px 6px;

        i {
          margin-right: 3px;
        }

        &:hover {
          border: 1px solid $safe;
          background: rgba(0,156,225,0.1);
          color: $safe;
        }
      }
    }
  }
  .info {
    margin: 0 40px 30px 40px;
    font-size: 13px;

    .el-row {
      margin-bottom: 10px;

      .el-col {
        span.item {
          display: inline-block;
          width: 180px;
          background: #EEE;
          padding: 3px 6px;
          border-radius: 4px;
          margin-right: 10px;
        }
        span.updating {
          font-size: 13px;
          border-radius: 20px;
          padding: 1px 4px;
          border: 1px solid $border;
          margin-left: 10px;

          i.el-icon-refresh {
            animation: rotation 1s ease-in-out infinite;
          }
        }
        a.edit {
          color: #666;
          cursor: pointer;
          transition: all .3s ease-in-out;
          display: inline-block;
          background: #FFF;
          margin-left: 10px;
          margin-right: -10px;
          border: 1px solid $border;
          font-size: 11px;
          border-radius: 20px;
          padding: 3px 8px 3px 6px;

          i {
            margin-right: 3px;
          }

          &:hover {
            border: 1px solid $safe;
            background: rgba(0,156,225,0.1);
            color: $safe;
          }
        }
      }
    }
  }

  .services, .events, .groups {
    align-items: center;
    flex-wrap: wrap;
    display: flex;

    a.service, a.event, a.group {
      transition: all .3s ease-in-out;
      text-align: center;

      &:hover {
        cursor: pointer;
        border: 1px solid $safe;
        background: rgba(0,156,225,0.1);
        color: $safe;

        i.plus,span,h3,h4,img.type { color: $safe; }
      }
    }

    .service, .event, .group {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100px;
      height: 100px;
      padding: 10px;
      background: #FAFAFA;
      border: 1px solid $border;
      border-radius: 7px;
      margin: 0 10px 10px 0;
      text-align: center;

      img.type {
        width: 40%;
        opacity: 0.4;
        margin: 10px auto -10px auto;
      }

      i.plus {
        transition: all .3s ease-in-out;
        font-size: 30px;
        margin-bottom: 5px;
        color: #666;
      }

      span {
        transition: all .3s ease-in-out;
        color: #666;
      }

      h3 {
        color: #999;
        font-size: 14px;
        font-weight: normal;
        margin: 20px 0 0 0;
        word-wrap: break-word;
      }

      h4 {
        font-size: 14px;
        font-weight: normal;
        color: #999;
        margin: 20px 0 0 0;
        line-height: 18px;
        word-wrap: break-word;
      }

      p.manager {
        color: #999;
        line-height: 20px;
        img.thumb {
          width: 20px;
          height: 20px;
          border-radius: 10px;
          margin-right: 4px;
          vertical-align: bottom;
        }
      }
    }
  }
}

.el-dialog {
  .input-form {
    display: flex;
    margin-bottom: 10px;
    label {
      width: 100px;
      padding: 10px;
      &.double {
        width: 200px;
      }
      &.caution:after {
        content: "*";
        color: $danger;
      }
    }
    .el-input {
      &.lat {
        margin-right: 10px;
      }
    }
  }
  .services {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;

    a.service {
      transition: all .3s ease-in-out;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 10px;
      text-align: center;
      border: 1px solid $border;
      border-radius: 5px;
      width: 100px;
      height: 100px;
      padding: 10px;

      img {
        margin:10px 0 5px 0;
      }

      &.active {
        border: 1px solid $safe;
        background: rgba(0,156,225,0.1);
        color: $safe;
        pointer-events: none;
      }

      &:hover {
        cursor: pointer;
        border:1px solid $safe;
        background: rgba(0,156,225,0.1);
        color: $safe;

        i.plus,span { color: $safe; }
      }
    }
  }
}

</style>
